// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
  font-family: "Proxima Nova", sans-serif;
  display: flex;
  position: relative;
}
.dashboard-container .collapse-menu {
  display: none;
  position: fixed;
}
.dashboard-container .sidebar-contents-container {
  position: fixed;
  background-color: white;
}
.dashboard-container .sidebar-contents-container .dashboard-header {
  display: flex;
  height: 60px;
  padding: 24px;
  border-bottom: 1px solid #E4E4E4;
  column-gap: 16px;
  align-items: center;
}
.dashboard-container .sidebar-contents-container .dashboard-header > p {
  margin: 0;
  font-weight: 700;
  font-size: 16px;
  color: var(--secondary-color-1);
}
.dashboard-container .sidebar-contents-container .dashboard-header > span {
  font-size: 16px;
  font-weight: 600;
  color: #949494;
}
.dashboard-container .sidebar-contents-container .pending-inquiry {
  background-color: #FF5151;
  position: absolute;
  border-radius: 3px;
  height: 15px;
  width: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  top: -5px;
  left: -5px;
}
.dashboard-container .sidebar-contents-container .pending-inquiry > p {
  font-size: 12px;
  font-weight: 700;
  color: white;
  margin: 0;
}
.dashboard-container .sidebar-contents-container .dashboard-sidebar {
  display: flex;
  position: relative;
  height: calc(100vh - 120px);
}
.dashboard-container .sidebar-contents-container .dashboard-sidebar .outer {
  width: 80px;
  border-right: 1px solid #E4E4E4;
  padding-top: 16px;
}
.dashboard-container .sidebar-contents-container .dashboard-sidebar .outer ul {
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  align-items: center;
}
.dashboard-container .sidebar-contents-container .dashboard-sidebar .outer ul > li {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: #F3F3F3;
  border-radius: 12px;
  cursor: pointer;
  transition: 0.3s ease-in-out;
}
.dashboard-container .sidebar-contents-container .dashboard-sidebar .outer ul > li:hover {
  opacity: 0.75;
}
.dashboard-container .sidebar-contents-container .dashboard-sidebar .outer ul > li.active {
  background-color: var(--primary-color-1);
}
.dashboard-container .sidebar-contents-container .dashboard-sidebar .pro-sidebar .pro-menu {
  padding: 0;
}
.dashboard-container .sidebar-contents-container .dashboard-sidebar .sidebar-container {
  display: flex;
}
.dashboard-container .sidebar-contents-container .dashboard-sidebar .sidebar-container .menu-icon.close {
  position: absolute;
  right: 10px;
  top: 10px;
}
.dashboard-container .sidebar-contents-container .dashboard-sidebar .sidebar-container .badge {
  background-color: #FF5151;
  height: 25px;
  width: 25px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #FFF;
  font-family: proxima-nova;
  font-weight: bold;
  font-size: 12px;
}
.dashboard-container .sidebar-contents-container .dashboard-sidebar .sidebar-container .collapsed .suffix-wrapper {
  opacity: 1 !important;
}
.dashboard-container .sidebar-contents-container .dashboard-sidebar .sidebar-container .pro-menu-item {
  padding-right: 0px;
  margin-left: 26px;
  width: 171px;
  height: 40px;
  border-radius: 12px;
}
.dashboard-container .sidebar-contents-container .dashboard-sidebar .sidebar-container .pro-menu-item.active {
  background-color: var(--primary-color-1);
}
.dashboard-container .sidebar-contents-container .dashboard-sidebar .sidebar-container .pro-menu-item.active .pro-item-content {
  color: #FFFFFF !important;
}
.dashboard-container .sidebar-contents-container .dashboard-sidebar .sidebar-container .pro-menu-item.active.pro-menu-item .left {
  display: block;
}
.dashboard-container .sidebar-contents-container .dashboard-sidebar .sidebar-container .left {
  display: none;
  position: absolute;
  left: -16px;
  width: 6px;
  height: 30px;
  border-radius: 8px;
  background-color: #FAC91F;
}
.dashboard-container .sidebar-contents-container .dashboard-sidebar .sidebar-container .pro-menu-item:hover .left {
  display: block;
}
.dashboard-container .sidebar-contents-container .dashboard-sidebar .sidebar-container .pro-sidebar {
  width: 220px;
  min-width: 220px;
  border-right: 1px solid #E4E4E4;
}
.dashboard-container .sidebar-contents-container .dashboard-sidebar .sidebar-container .pro-sidebar > .pro-sidebar-inner {
  background: none;
}
.dashboard-container .sidebar-contents-container .dashboard-sidebar .sidebar-container .pro-sidebar-content {
  padding-top: 16px;
}
.dashboard-container .sidebar-contents-container .dashboard-sidebar .sidebar-container .pro-inner-item {
  padding: 10px 16px !important;
  margin-left: 0px !important;
  height: 40px;
}
.dashboard-container .sidebar-contents-container .dashboard-sidebar .sidebar-container .pro-icon-wrapper {
  width: 20px !important;
  height: 20px !important;
  min-width: 0 !important;
  margin-right: 0 !important;
}
.dashboard-container .sidebar-contents-container .dashboard-sidebar .sidebar-container .pro-item-content {
  display: flex;
  align-items: center;
  margin: 0 0 0 10px;
  text-align: left;
  font-size: 14px;
  font-weight: bold;
  font-family: proxima-nova;
  color: #949494;
  opacity: 1;
}
.dashboard-container .sidebar-contents-container .dashboard-sidebar .sidebar-container .pro-sidebar-footer {
  display: flex;
  padding: 35px 50px;
  border-top-width: 0px !important;
}
.dashboard-container .outlet-container {
  flex: 1 1;
  margin-left: 300px;
}

@media (min-width: 768px) and (max-width: 1024px), (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .dashboard-container .sidebar-contents-container {
    left: -300px;
    transition: 0.5s ease-in-out;
    z-index: 98;
    box-shadow: 0px 4px 20px rgba(53, 99, 55, 0.2);
  }
  .dashboard-container .sidebar-contents-container.show {
    left: 0;
  }
  .dashboard-container .outlet-container {
    margin-left: 0;
  }
  .dashboard-container .collapse-menu {
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 97;
    top: 150px;
    background-color: var(--primary-color-1);
    padding: 10px 10px 10px 15px;
    border-radius: 6px;
    left: -10px;
    transition: 0.5s ease-in-out;
  }
  .dashboard-container .collapse-menu.show {
    left: 290px;
  }
}
@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .dashboard-container .sidebar-contents-container {
    left: -300px;
    transition: 0.5s ease-in-out;
    z-index: 98;
    box-shadow: 0px 4px 20px rgba(53, 99, 55, 0.2);
  }
  .dashboard-container .sidebar-contents-container.show {
    left: 0;
  }
  .dashboard-container .outlet-container {
    margin-left: 0;
  }
  .dashboard-container .collapse-menu {
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 97;
    top: 150px;
    background-color: var(--primary-color-1);
    padding: 10px 10px 10px 15px;
    border-radius: 6px;
    left: -10px;
    transition: 0.5s ease-in-out;
  }
  .dashboard-container .collapse-menu.show {
    left: 290px;
  }
}
@keyframes swing {
  0%, 30%, 50%, 70%, 100% {
    transform: rotate(0deg);
  }
  10% {
    transform: rotate(10deg);
  }
  40% {
    transform: rotate(-10deg);
  }
  60% {
    transform: rotate(5deg);
  }
  80% {
    transform: rotate(-5deg);
  }
}
.pro-sidebar {
  color: #adadad;
  height: 100%;
  width: 340px;
  min-width: 340px;
  text-align: left;
  transition: width, left, right, 0.3s;
  position: relative;
  z-index: 1009;
}
.pro-sidebar > .pro-sidebar-inner {
  background: #fff;
  height: 100%;
  position: relative;
  z-index: 101;
}
.pro-sidebar > .pro-sidebar-inner > img.sidebar-bg {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  position: absolute;
  opacity: 0.3;
  left: 0;
  top: 0;
  z-index: 100;
}
.pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  z-index: 101;
}
.pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout .pro-sidebar-header {
  border-bottom: 1px solid rgba(173, 173, 173, 0.2);
}
.pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout .pro-sidebar-content {
  flex-grow: 1;
}
.pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout .pro-sidebar-footer {
  border-top: 1px solid rgba(173, 173, 173, 0.2);
}
.pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.pro-sidebar .overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 100;
  display: none;
}
.pro-sidebar.collapsed {
  width: 80px;
  min-width: 80px;
}
.pro-sidebar.rtl {
  text-align: right;
  direction: rtl;
}
@media (max-width: 480px) {
  .pro-sidebar.xs {
    position: fixed;
    left: -340px;
  }
  .pro-sidebar.xs.collapsed {
    left: -80px;
  }
  .pro-sidebar.xs.toggled {
    left: 0;
  }
  .pro-sidebar.xs.toggled .overlay {
    display: block;
  }
  .pro-sidebar.xs.rtl {
    left: auto;
    right: -340px;
  }
  .pro-sidebar.xs.rtl.collapsed {
    left: auto;
    right: -80px;
  }
  .pro-sidebar.xs.rtl.toggled {
    left: auto;
    right: 0;
  }
}
@media (max-width: 576px) {
  .pro-sidebar.sm {
    position: fixed;
    left: -340px;
  }
  .pro-sidebar.sm.collapsed {
    left: -80px;
  }
  .pro-sidebar.sm.toggled {
    left: 0;
  }
  .pro-sidebar.sm.toggled .overlay {
    display: block;
  }
  .pro-sidebar.sm.rtl {
    left: auto;
    right: -340px;
  }
  .pro-sidebar.sm.rtl.collapsed {
    left: auto;
    right: -80px;
  }
  .pro-sidebar.sm.rtl.toggled {
    left: auto;
    right: 0;
  }
}
@media (max-width: 768px) {
  .pro-sidebar.md {
    position: fixed;
    left: -340px;
  }
  .pro-sidebar.md.collapsed {
    left: -80px;
  }
  .pro-sidebar.md.toggled {
    left: 0;
  }
  .pro-sidebar.md.toggled .overlay {
    display: block;
  }
  .pro-sidebar.md.rtl {
    left: auto;
    right: -340px;
  }
  .pro-sidebar.md.rtl.collapsed {
    left: auto;
    right: -80px;
  }
  .pro-sidebar.md.rtl.toggled {
    left: auto;
    right: 0;
  }
}
@media (max-width: 992px) {
  .pro-sidebar.lg {
    position: fixed;
    left: -340px;
  }
  .pro-sidebar.lg.collapsed {
    left: -80px;
  }
  .pro-sidebar.lg.toggled {
    left: 0;
  }
  .pro-sidebar.lg.toggled .overlay {
    display: block;
  }
  .pro-sidebar.lg.rtl {
    left: auto;
    right: -340px;
  }
  .pro-sidebar.lg.rtl.collapsed {
    left: auto;
    right: -80px;
  }
  .pro-sidebar.lg.rtl.toggled {
    left: auto;
    right: 0;
  }
}
@media (max-width: 1200px) {
  .pro-sidebar.xl {
    position: fixed;
    left: -340px;
  }
  .pro-sidebar.xl.collapsed {
    left: -80px;
  }
  .pro-sidebar.xl.toggled {
    left: 0;
  }
  .pro-sidebar.xl.toggled .overlay {
    display: block;
  }
  .pro-sidebar.xl.rtl {
    left: auto;
    right: -340px;
  }
  .pro-sidebar.xl.rtl.collapsed {
    left: auto;
    right: -80px;
  }
  .pro-sidebar.xl.rtl.toggled {
    left: auto;
    right: 0;
  }
}
@media (max-width: 1600px) {
  .pro-sidebar.xxl {
    position: fixed;
    left: -340px;
  }
  .pro-sidebar.xxl.collapsed {
    left: -80px;
  }
  .pro-sidebar.xxl.toggled {
    left: 0;
  }
  .pro-sidebar.xxl.toggled .overlay {
    display: block;
  }
  .pro-sidebar.xxl.rtl {
    left: auto;
    right: -340px;
  }
  .pro-sidebar.xxl.rtl.collapsed {
    left: auto;
    right: -80px;
  }
  .pro-sidebar.xxl.rtl.toggled {
    left: auto;
    right: 0;
  }
}

.pro-sidebar .pro-menu.submenu-bullets .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item:before {
  content: "";
  display: inline-block;
  width: 4px;
  min-width: 4px;
  height: 4px;
  border: 1px solid #2b2b2b;
  border-radius: 50%;
  margin-right: 15px;
  position: relative;
  box-shadow: 1px 0px 0px #adadad, 0px -1px 0px #adadad, 0px 1px 0px #adadad, -1px 0px 0px #adadad;
}

.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item > .pro-item-content {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pro-sidebar .pro-menu {
  padding-top: 10px;
  padding-bottom: 10px;
}
.pro-sidebar .pro-menu > ul > .pro-sub-menu > .pro-inner-list-item {
  position: relative;
  background-color: #2b2b2b;
}
.pro-sidebar .pro-menu > ul > .pro-sub-menu > .pro-inner-list-item > div > ul {
  padding-top: 15px;
  padding-bottom: 15px;
}
.pro-sidebar .pro-menu a {
  text-decoration: none;
  color: #adadad;
}
.pro-sidebar .pro-menu a:before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: transparent;
}
.pro-sidebar .pro-menu a:hover {
  color: #2A2A2A;
}
.pro-sidebar .pro-menu .pro-menu-item {
  font-size: 15px;
}
.pro-sidebar .pro-menu .pro-menu-item.active {
  color: #2A2A2A;
}
.pro-sidebar .pro-menu .pro-menu-item .suffix-wrapper {
  opacity: 1;
  transition: opacity 0.2s;
}
.pro-sidebar .pro-menu .pro-menu-item .prefix-wrapper {
  display: flex;
  margin-right: 5px;
  opacity: 1;
  transition: opacity 0.2s;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item {
  position: relative;
  display: flex;
  align-items: center;
  padding: 8px 35px 8px 20px;
  cursor: pointer;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item:focus {
  outline: none;
  color: #2A2A2A;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  margin-right: 10px;
  font-size: 14px;
  width: 35px;
  min-width: 35px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  display: inline-block;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item > .pro-icon-wrapper .pro-icon {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item > .pro-item-content {
  flex-grow: 1;
  flex-shrink: 1;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item:hover {
  color: #2A2A2A;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item:hover .pro-icon-wrapper .pro-icon {
  animation: swing ease-in-out 0.5s 1 alternate;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item:before {
  background: #adadad;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper .pro-arrow {
  display: inline-block;
  border-style: solid;
  border-color: #adadad;
  border-width: 0 2px 2px 0;
  padding: 2.5px;
  vertical-align: middle;
  transition: transform 0.3s;
  transform: rotate(-45deg);
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu.open > .pro-inner-item:before {
  background: transparent !important;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu.open > .pro-inner-item > .pro-arrow-wrapper .pro-arrow {
  transform: rotate(45deg);
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item {
  padding-left: 24px;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {
  padding: 8px 30px 8px 15px;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item > .pro-icon-wrapper {
  background: none;
  width: auto;
  min-width: auto;
  height: auto;
  line-height: auto;
}
.pro-sidebar .pro-menu:not(.inner-submenu-arrows) .pro-inner-list-item .pro-menu-item.pro-sub-menu .pro-inner-item .pro-arrow-wrapper {
  display: none;
}
.pro-sidebar .pro-menu.shaped .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  background-color: #2b2b2b;
}
.pro-sidebar .pro-menu.square .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  border-radius: 0;
}
.pro-sidebar .pro-menu.round .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  border-radius: 4px;
}
.pro-sidebar .pro-menu.circle .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  border-radius: 50%;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item {
  position: relative;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item > .pro-inner-item > .suffix-wrapper,
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item > .pro-inner-item > .prefix-wrapper {
  opacity: 0;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item > .pro-inner-list-item {
  background-color: #2b2b2b;
  z-index: 111;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item::before {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  cursor: pointer;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu {
  position: relative;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-item {
  pointer-events: none;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper {
  display: none;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item {
  height: auto !important;
  position: fixed;
  visibility: hidden;
  min-width: 220px;
  max-width: 270px;
  background-color: transparent;
  max-height: 100%;
  padding-left: 3px;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item.has-arrow {
  padding-left: 10px;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item > .popper-inner {
  max-height: 100vh;
  overflow-y: auto;
  background-color: #2b2b2b;
  padding-left: 20px;
  border-radius: 4px;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu:hover > .pro-inner-list-item {
  transition: visibility, transform 0.3s;
  visibility: visible;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu:hover .pro-icon-wrapper .pro-icon {
  animation: swing ease-in-out 0.5s 1 alternate;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-sub-menu-item,
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {
  padding: 8px 30px 8px 5px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item .prefix-wrapper {
  margin-right: 0;
  margin-left: 5px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item > .pro-inner-item {
  padding: 8px 20px 8px 35px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  margin-right: 0;
  margin-left: 10px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper {
  right: auto;
  left: 20px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper .pro-arrow {
  transform: rotate(135deg);
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu.open > .pro-inner-item > .pro-arrow-wrapper .pro-arrow {
  transform: rotate(45deg);
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item {
  padding-left: 0;
  padding-right: 24px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {
  padding: 8px 15px 8px 30px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item:before {
  margin-right: 0;
  margin-left: 15px;
}
.pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item {
  padding-left: 0;
  padding-right: 3px;
}
.pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item.has-arrow {
  padding-right: 10px;
}
.pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item > .popper-inner {
  padding-left: 0;
  padding-right: 20px;
}
.pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-sub-menu-item,
.pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {
  padding: 8px 5px 8px 30px;
}

.popper-arrow {
  position: absolute;
  z-index: -1;
  width: 0;
  height: 0;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
}

.popper-element[data-popper-placement^=left] > .popper-arrow {
  right: 0;
  border-right: 7px solid #2b2b2b;
}

.popper-element[data-popper-placement^=right] > .popper-arrow {
  left: 0;
  border-left: 7px solid #2b2b2b;
}

.react-slidedown {
  height: 0;
  transition-property: none;
  transition-duration: 0.2s;
  transition-timing-function: ease-in-out;
}

.react-slidedown.transitioning {
  overflow-y: hidden;
}

.react-slidedown.closed {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/components/DashboardContainer/dashboardContainer.scss","webpack://./src/assets/styles/_mixins.scss","webpack://./node_modules/react-pro-sidebar/dist/scss/partials/_animation.scss","webpack://./node_modules/react-pro-sidebar/dist/scss/partials/_sidebar.scss","webpack://./node_modules/react-pro-sidebar/dist/scss/variables.scss","webpack://./node_modules/react-pro-sidebar/dist/scss/partials/_menu.scss","webpack://./node_modules/react-pro-sidebar/dist/scss/partials/_popperArrow.scss","webpack://./node_modules/react-pro-sidebar/dist/scss/partials/_reactSlidedown.scss"],"names":[],"mappings":"AAMA;EACI,uCAAA;EACA,aAAA;EACA,kBAAA;AALJ;AAMI;EACI,aAAA;EACA,eAAA;AAJR;AAMI;EACI,eAAA;EACA,uBAAA;AAJR;AAKQ;EACI,aAAA;EACA,YAAA;EACA,aAAA;EACA,gCAAA;EACA,gBAAA;EACA,mBAAA;AAHZ;AAKY;EACI,SAAA;EACA,gBAAA;EACA,eAAA;EACA,+BAAA;AAHhB;AAMY;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAJhB;AAOQ;EACI,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,UAAA;AALZ;AAMY;EACI,eAAA;EACA,gBAAA;EACA,YAAA;EACA,SAAA;AAJhB;AAOQ;EACI,aAAA;EACA,kBAAA;EACA,2BAAA;AALZ;AAMY;EACI,WAAA;EACA,+BAAA;EACA,iBAAA;AAJhB;AAKgB;EACI,aAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;AAHpB;AAIoB;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,4BAAA;AAFxB;AAGwB;EACI,aAAA;AAD5B;AAGwB;EACI,wCAAA;AAD5B;AAMY;EACI,UAAA;AAJhB;AAMY;EACI,aAAA;AAJhB;AAMoB;EACI,kBAAA;EACA,WAAA;EACA,SAAA;AAJxB;AAQgB;EACI,yBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;AANpB;AASgB;EACI,qBAAA;AAPpB;AAgBgB;EACI,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;AAdpB;AAeoB;EACI,wCAAA;AAbxB;AAcwB;EACI,yBAAA;AAZ5B;AAcwB;EACI,cAAA;AAZ5B;AAiBgB;EACI,aAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AAfpB;AAkBgB;EACI,cAAA;AAhBpB;AAkBgB;EACI,YAAA;EACA,gBAAA;EACA,+BAAA;AAhBpB;AAkBgB;EACI,gBAAA;AAhBpB;AAkBgB;EACI,iBAAA;AAhBpB;AAkBgB;EACI,6BAAA;EACA,2BAAA;EACA,YAAA;AAhBpB;AAkBgB;EACI,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,0BAAA;AAhBpB;AAkBgB;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,cAAA;EACA,UAAA;AAhBpB;AAmBgB;EACI,aAAA;EACA,kBAAA;EACA,gCAAA;AAjBpB;AAuBI;EACI,SAAA;EACA,kBAAA;AArBR;;AC1KY;EDqMJ;IACI,YAAA;IACA,4BAAA;IACA,WAAA;IACA,8CAAA;EAvBV;EAwBU;IACI,OAAA;EAtBd;EAyBM;IACI,cAAA;EAvBV;EAyBM;IACI,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,WAAA;IACA,UAAA;IACA,wCAAA;IACA,4BAAA;IACA,kBAAA;IACA,WAAA;IACA,4BAAA;EAvBV;EAwBU;IACI,WAAA;EAtBd;AACF;AC/MY;ED4MJ;IACI,YAAA;IACA,4BAAA;IACA,WAAA;IACA,8CAAA;EAMV;EALU;IACI,OAAA;EAOd;EAJM;IACI,cAAA;EAMV;EAJM;IACI,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,WAAA;IACA,UAAA;IACA,wCAAA;IACA,4BAAA;IACA,kBAAA;IACA,WAAA;IACA,4BAAA;EAMV;EALU;IACI,WAAA;EAOd;AACF;AE/OA;EACE;IAKE,uBAAA;EF6OF;EE1OA;IACE,wBAAA;EF4OF;EEzOA;IACE,yBAAA;EF2OF;EExOA;IACE,uBAAA;EF0OF;EEvOA;IACE,wBAAA;EFyOF;AACF;AGtOA;EACE,cC1Bc;ED2Bd,YAAA;EACA,YHzBc;EG0Bd,gBH1Bc;EG2Bd,gBAAA;EACA,oCAAA;EACA,kBAAA;EACA,aAAA;AHwOF;AGvOE;EACE,gBHlCe;EGmCf,YAAA;EACA,kBAAA;EACA,YAAA;AHyOJ;AGvOI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;AHyON;AGtOI;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AHwON;AGtOM;EACE,iDAAA;AHwOR;AGtOM;EACE,YAAA;AHwOR;AGtOM;EACE,8CAAA;AHwOR;AGtOM;EACE,qBAAA;EACA,UAAA;EACA,SAAA;AHwOR;AGnOE;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,oCAAA;EACA,YAAA;EACA,aAAA;AHqOJ;AGlOE;EACE,WCxFsB;EDyFtB,eCzFsB;AJ6T1B;AGjOE;EACE,iBAAA;EACA,cAAA;AHmOJ;AG/NI;EADF;IAnGA,eAAA;IACA,YAAA;EHuUA;EGtUA;IACE,WAAA;EHwUF;EGtUA;IACE,OAAA;EHwUF;EGvUE;IACE,cAAA;EHyUJ;EGtUA;IACE,UAAA;IACA,aAAA;EHwUF;EGvUE;IACE,UAAA;IACA,YAAA;EHyUJ;EGvUE;IACE,UAAA;IACA,QAAA;EHyUJ;AACF;AGrPI;EADF;IAxGA,eAAA;IACA,YAAA;EHkWA;EGjWA;IACE,WAAA;EHmWF;EGjWA;IACE,OAAA;EHmWF;EGlWE;IACE,cAAA;EHoWJ;EGjWA;IACE,UAAA;IACA,aAAA;EHmWF;EGlWE;IACE,UAAA;IACA,YAAA;EHoWJ;EGlWE;IACE,UAAA;IACA,QAAA;EHoWJ;AACF;AG3QI;EADF;IA7GA,eAAA;IACA,YAAA;EH6XA;EG5XA;IACE,WAAA;EH8XF;EG5XA;IACE,OAAA;EH8XF;EG7XE;IACE,cAAA;EH+XJ;EG5XA;IACE,UAAA;IACA,aAAA;EH8XF;EG7XE;IACE,UAAA;IACA,YAAA;EH+XJ;EG7XE;IACE,UAAA;IACA,QAAA;EH+XJ;AACF;AGjSI;EADF;IAlHA,eAAA;IACA,YAAA;EHwZA;EGvZA;IACE,WAAA;EHyZF;EGvZA;IACE,OAAA;EHyZF;EGxZE;IACE,cAAA;EH0ZJ;EGvZA;IACE,UAAA;IACA,aAAA;EHyZF;EGxZE;IACE,UAAA;IACA,YAAA;EH0ZJ;EGxZE;IACE,UAAA;IACA,QAAA;EH0ZJ;AACF;AGvTI;EADF;IAvHA,eAAA;IACA,YAAA;EHmbA;EGlbA;IACE,WAAA;EHobF;EGlbA;IACE,OAAA;EHobF;EGnbE;IACE,cAAA;EHqbJ;EGlbA;IACE,UAAA;IACA,aAAA;EHobF;EGnbE;IACE,UAAA;IACA,YAAA;EHqbJ;EGnbE;IACE,UAAA;IACA,QAAA;EHqbJ;AACF;AG7UI;EADF;IA5HA,eAAA;IACA,YAAA;EH8cA;EG7cA;IACE,WAAA;EH+cF;EG7cA;IACE,OAAA;EH+cF;EG9cE;IACE,cAAA;EHgdJ;EG7cA;IACE,UAAA;IACA,aAAA;EH+cF;EG9cE;IACE,UAAA;IACA,YAAA;EHgdJ;EG9cE;IACE,UAAA;IACA,QAAA;EHgdJ;AACF;;AKreE;EACE,WAAA;EACA,qBAAA;EACA,UAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gGAAA;ALweJ;;AKneA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;ALseF;;AKleE;EACE,iBAAA;EACA,oBAAA;ALqeJ;AKjeQ;EACE,kBAAA;EACA,yBD1BS;AJ6fnB;AKjeU;EACE,iBAAA;EACA,oBAAA;ALmeZ;AK9dI;EACE,qBAAA;EACA,cDzCU;AJygBhB;AK/dM;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,6BAAA;ALieR;AK/dM;EACE,cLlDU;AAmhBlB;AK9dI;EACE,eAAA;ALgeN;AK/dM;EACE,cLxDU;AAyhBlB;AK9dM;EACE,UAAA;EACA,wBAAA;ALgeR;AK9dM;EACE,aAAA;EACA,iBAAA;EACA,UAAA;EACA,wBAAA;ALgeR;AK7dM;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,eAAA;AL+dR;AK7dQ;EACE,aAAA;EACA,cL/EQ;AA8iBlB;AK7dQ;EACE,kBAAA;EACA,eAAA;EACA,WD/EE;ECgFF,eDhFE;ECiFF,YDjFE;ECkFF,iBDlFE;ECmFF,kBAAA;EACA,qBAAA;AL+dV;AK7dU;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AL+dZ;AK3dQ;EACE,YAAA;EACA,cAAA;AL6dV;AKxdQ;EACE,cL3GQ;AAqkBlB;AKxdY;EACE,6CAAA;AL0dd;AKldU;EACE,mBDzHI;AJ6kBhB;AKjdU;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;ALmdZ;AKjdY;EACE,qBAAA;EACA,mBAAA;EACA,qBDrIE;ECsIF,yBAAA;EACA,cAAA;EACA,sBAAA;EACA,0BAAA;EACA,yBAAA;ALmdd;AK5cY;EACE,kCAAA;AL8cd;AK3cc;EACE,wBAAA;AL6chB;AKvcQ;EACE,kBDrJO;AJ8lBjB;AKvcU;EACE,0BAAA;ALycZ;AKvcY;EACE,gBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;ALycd;AKjcM;EACE,aAAA;ALmcR;AKvbU;EACE,yBDvLI;AJgnBhB;AKhbU;EACE,gBAAA;ALkbZ;AK1aU;EACE,kBAAA;AL4aZ;AKpaU;EACE,kBAAA;ALsaZ;AK1ZQ;EAWE,kBAAA;ALkZV;AK3ZY;;EAEE,UAAA;AL6Zd;AK1ZU;EACE,yBDxOiB;ECyOjB,YAAA;AL4ZZ;AKzZU;EACE,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,eAAA;AL2ZZ;AKzZU;EACE,kBAAA;AL2ZZ;AKzZY;EACE,oBAAA;AL2Zd;AKzZc;EACE,aAAA;AL2ZhB;AKxZY;EACE,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,gBAAA;EACA,iBAAA;AL0Zd;AKzZc;EACE,kBAAA;AL2ZhB;AKzZc;EACE,iBAAA;EACA,gBAAA;EACA,yBD/Qa;ECgRb,kBAAA;EACA,kBAAA;AL2ZhB;AKvZc;EACE,sCAAA;EACA,mBAAA;ALyZhB;AKtZgB;EACE,6CAAA;ALwZlB;AKlZc;;EAEE,yBAAA;ALoZhB;AKvYQ;EACE,eAAA;EACA,gBAAA;ALyYV;AKvYQ;EACE,0BAAA;ALyYV;AKxYU;EACE,eAAA;EACA,iBAAA;AL0YZ;AKpYY;EACE,WAAA;EACA,UAAA;ALsYd;AKrYc;EACE,yBAAA;ALuYhB;AKhYgB;EACE,wBAAA;ALkYlB;AK5XU;EACE,eAAA;EACA,mBD/UK;AJ6sBjB;AK5XY;EACE,0BAAA;AL8Xd;AK7Xc;EACE,eAAA;EACA,iBAAA;AL+XhB;AKjXc;EACE,eAAA;EACA,kBAAA;ALmXhB;AKlXgB;EACE,mBAAA;ALoXlB;AKlXgB;EACE,eAAA;EACA,mBAAA;ALoXlB;AK/WgB;;EAEE,yBAAA;ALiXlB;;AM5uBA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,iCAAA;EACA,oCAAA;AN+uBF;;AM5uBA;EACE,QAAA;EACA,+BAAA;AN+uBF;;AM5uBA;EACE,OAAA;EACA,8BAAA;AN+uBF;;AO/vBA;EACE,SAAA;EACA,yBAAA;EACA,yBAAA;EACA,uCAAA;APkwBF;;AO/vBA;EACE,kBAAA;APkwBF;;AO/vBA;EACE,aAAA;APkwBF","sourcesContent":["@import 'assets/styles/_mixins.scss';\r\n\r\n$sidebar-bg-color: #fff;\r\n$highlight-color: #2A2A2A !default;\r\n$sidebar-width: 340px !default;\r\n\r\n.dashboard-container {\r\n    font-family: 'Proxima Nova', sans-serif;\r\n    display: flex;\r\n    position: relative;\r\n    .collapse-menu {\r\n        display: none;\r\n        position: fixed;\r\n    }\r\n    .sidebar-contents-container {\r\n        position: fixed;\r\n        background-color: white;\r\n        .dashboard-header {\r\n            display: flex;\r\n            height: 60px;\r\n            padding: 24px;\r\n            border-bottom: 1px solid #E4E4E4;\r\n            column-gap: 16px;\r\n            align-items: center;\r\n    \r\n            >p {\r\n                margin: 0;\r\n                font-weight: 700;\r\n                font-size: 16px;\r\n                color: var(--secondary-color-1);\r\n            }\r\n    \r\n            >span {\r\n                font-size: 16px;\r\n                font-weight: 600;\r\n                color: #949494;\r\n            }\r\n        }\r\n        .pending-inquiry {\r\n            background-color: #FF5151;                            \r\n            position: absolute;\r\n            border-radius: 3px;\r\n            height: 15px;\r\n            width: 15px;\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            top: -5px;\r\n            left: -5px;\r\n            > p {\r\n                font-size: 12px;\r\n                font-weight: 700;\r\n                color: white;\r\n                margin: 0;\r\n            }\r\n        }\r\n        .dashboard-sidebar {\r\n            display: flex;\r\n            position: relative;\r\n            height: calc(100vh - 120px);\r\n            .outer {\r\n                width: 80px;\r\n                border-right: 1px solid #E4E4E4;\r\n                padding-top: 16px;\r\n                ul {\r\n                    display: flex;\r\n                    flex-direction: column;\r\n                    row-gap: 16px;\r\n                    align-items: center;\r\n                    > li {\r\n                        position: relative;\r\n                        display: flex;\r\n                        align-items: center;\r\n                        justify-content: center;\r\n                        width: 40px;\r\n                        height: 40px;\r\n                        background-color: #F3F3F3;\r\n                        border-radius: 12px;\r\n                        cursor: pointer;\r\n                        transition: .3s ease-in-out;\r\n                        &:hover {\r\n                            opacity: .75;\r\n                        }\r\n                        &.active {\r\n                            background-color: var(--primary-color-1);\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n            .pro-sidebar .pro-menu {\r\n                padding: 0;\r\n            }\r\n            .sidebar-container {\r\n                display: flex;\r\n                .menu-icon {\r\n                    &.close {\r\n                        position: absolute;\r\n                        right: 10px;\r\n                        top: 10px;\r\n                    }\r\n                }\r\n    \r\n                .badge {\r\n                    background-color: #FF5151;\r\n                    height: 25px;\r\n                    width: 25px;\r\n                    border-radius: 5px;\r\n                    display: flex;\r\n                    justify-content: center;\r\n                    align-items: center;\r\n                    color: #FFF;\r\n                    font-family: proxima-nova;\r\n                    font-weight: bold;\r\n                    font-size: 12px;\r\n                }\r\n    \r\n                .collapsed .suffix-wrapper {\r\n                    opacity: 1 !important;\r\n                }\r\n    \r\n                // .pro-sidebar {\r\n                //   border-width: 1px;\r\n                //   border-right-color: #BEBEBE;\r\n                //   border-right-style: solid;\r\n                // }\r\n    \r\n                .pro-menu-item {\r\n                    padding-right: 0px;\r\n                    margin-left: 26px;\r\n                    width: 171px;\r\n                    height: 40px;\r\n                    border-radius: 12px;\r\n                    &.active {\r\n                        background-color: var(--primary-color-1);\r\n                        .pro-item-content {\r\n                            color: #FFFFFF !important;\r\n                        }\r\n                        &.pro-menu-item .left {\r\n                            display: block;\r\n                        }\r\n                    }\r\n                }\r\n    \r\n                .left {\r\n                    display: none;\r\n                    position: absolute;\r\n                    left: -16px;\r\n                    width: 6px;\r\n                    height: 30px;\r\n                    border-radius: 8px;\r\n                    background-color: #FAC91F;\r\n                }\r\n    \r\n                .pro-menu-item:hover .left {\r\n                    display: block;\r\n                }\r\n                .pro-sidebar {\r\n                    width: 220px;\r\n                    min-width: 220px;\r\n                    border-right: 1px solid #E4E4E4;\r\n                }\r\n                .pro-sidebar > .pro-sidebar-inner {\r\n                    background: none;\r\n                }\r\n                .pro-sidebar-content {\r\n                    padding-top: 16px;\r\n                }\r\n                .pro-inner-item {\r\n                    padding: 10px 16px !important;\r\n                    margin-left: 0px !important;\r\n                    height: 40px;\r\n                }\r\n                .pro-icon-wrapper {\r\n                    width: 20px !important;\r\n                    height: 20px !important;\r\n                    min-width: 0 !important;\r\n                    margin-right: 0 !important;\r\n                }\r\n                .pro-item-content {\r\n                    display: flex;\r\n                    align-items: center;\r\n                    margin: 0 0 0 10px;\r\n                    text-align: left;\r\n                    font-size: 14px;\r\n                    font-weight: bold;\r\n                    font-family: proxima-nova;\r\n                    color: #949494;\r\n                    opacity: 1;\r\n                }\r\n    \r\n                .pro-sidebar-footer {\r\n                    display: flex;\r\n                    padding: 35px 50px;\r\n                    border-top-width: 0px !important;\r\n                }\r\n            }\r\n    \r\n        }\r\n    }\r\n    .outlet-container {\r\n        flex: 1;\r\n        margin-left: 300px;\r\n    }\r\n}\r\n\r\n@include media(tablet, mobile) {\r\n    .dashboard-container {\r\n        .sidebar-contents-container {\r\n            left: -300px;\r\n            transition: .5s ease-in-out;\r\n            z-index: 98;\r\n            box-shadow: 0px 4px 20px rgba(53, 99, 55, 0.2);\r\n            &.show {\r\n                left: 0;\r\n            }\r\n        }\r\n        .outlet-container {\r\n            margin-left: 0;\r\n        }\r\n        .collapse-menu {\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            z-index: 97;\r\n            top: 150px;\r\n            background-color: var(--primary-color-1);\r\n            padding: 10px 10px 10px 15px;\r\n            border-radius: 6px;\r\n            left: -10px;\r\n            transition: .5s ease-in-out;\r\n            &.show {\r\n                left: 290px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@import '~react-pro-sidebar/dist/scss/styles.scss';","@mixin media($keys...) {\r\n    @each $key in $keys {\r\n        @if ($key==mobile) {\r\n            @media (min-width: 481px) and (max-width: 767px),\r\n            (min-width: 320px) and (max-width: 480px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==tablet) {\r\n            @media (min-width: 768px) and (max-width: 1024px),\r\n            (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==nitty-gritt) {\r\n            @media (width: 1024px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==small-desktop) {\r\n            @media (max-width: 1440px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==desktop) {\r\n            @media (min-width: 1024px) and (max-width: 1440px) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}","@keyframes swing {\n  0%,\n  30%,\n  50%,\n  70%,\n  100% {\n    transform: rotate(0deg);\n  }\n\n  10% {\n    transform: rotate(10deg);\n  }\n\n  40% {\n    transform: rotate(-10deg);\n  }\n\n  60% {\n    transform: rotate(5deg);\n  }\n\n  80% {\n    transform: rotate(-5deg);\n  }\n}\n","@mixin break-point {\n  position: fixed;\n  left: -$sidebar-width;\n  &.collapsed {\n    left: -$sidebar-collapsed-width;\n  }\n  &.toggled {\n    left: 0;\n    .overlay {\n      display: block;\n    }\n  }\n  &.rtl {\n    left: auto;\n    right: -$sidebar-width;\n    &.collapsed {\n      left: auto;\n      right: -$sidebar-collapsed-width;\n    }\n    &.toggled {\n      left: auto;\n      right: 0;\n    }\n  }\n}\n\n.pro-sidebar {\n  color: $sidebar-color;\n  height: 100%;\n  width: $sidebar-width;\n  min-width: $sidebar-width;\n  text-align: left;\n  transition: width, left, right, 0.3s;\n  position: relative;\n  z-index: 1009;\n  > .pro-sidebar-inner {\n    background: $sidebar-bg-color;\n    height: 100%;\n    position: relative;\n    z-index: 101;\n\n    > img.sidebar-bg {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      object-position: center;\n      position: absolute;\n      opacity: 0.3;\n      left: 0;\n      top: 0;\n      z-index: 100;\n    }\n\n    > .pro-sidebar-layout {\n      height: 100%;\n      overflow-y: auto;\n      overflow-x: hidden;\n      position: relative;\n      display: flex;\n      flex-direction: column;\n      z-index: 101;\n\n      .pro-sidebar-header {\n        border-bottom: 1px solid rgba($sidebar-color, 0.2);\n      }\n      .pro-sidebar-content {\n        flex-grow: 1;\n      }\n      .pro-sidebar-footer {\n        border-top: 1px solid rgba($sidebar-color, 0.2);\n      }\n      ul {\n        list-style-type: none;\n        padding: 0;\n        margin: 0;\n      }\n    }\n  }\n\n  .overlay {\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background-color: rgba(#000, 0.3);\n    z-index: 100;\n    display: none;\n  }\n\n  &.collapsed {\n    width: $sidebar-collapsed-width;\n    min-width: $sidebar-collapsed-width;\n  }\n\n  &.rtl {\n    text-align: right;\n    direction: rtl;\n  }\n\n  &.xs {\n    @media (max-width: $breakpoint-xs) {\n      @include break-point;\n    }\n  }\n  &.sm {\n    @media (max-width: $breakpoint-sm) {\n      @include break-point;\n    }\n  }\n  &.md {\n    @media (max-width: $breakpoint-md) {\n      @include break-point;\n    }\n  }\n  &.lg {\n    @media (max-width: $breakpoint-lg) {\n      @include break-point;\n    }\n  }\n  &.xl {\n    @media (max-width: $breakpoint-xl) {\n      @include break-point;\n    }\n  }\n  &.xxl {\n    @media (max-width: $breakpoint-xxl) {\n      @include break-point;\n    }\n  }\n}\n","$sidebar-bg-color: #1d1d1d !default;\n$sidebar-color: #adadad !default;\n$sidebar-width: 270px !default;\n$sidebar-collapsed-width: 80px !default;\n$highlight-color: #d8d8d8 !default;\n$submenu-bg-color: #2b2b2b !default;\n$submenu-bg-color-collapsed: #2b2b2b !default;\n$icon-bg-color: #2b2b2b !default;\n$icon-size: 35px !default;\n$submenu-indent: 24px !default;\n\n$breakpoint-xs: 480px !default;\n$breakpoint-sm: 576px !default;\n$breakpoint-md: 768px !default;\n$breakpoint-lg: 992px !default;\n$breakpoint-xl: 1200px !default;\n$breakpoint-xxl: 1600px !default;\n","%pro-item-prefix {\n  &:before {\n    content: '';\n    display: inline-block;\n    width: 4px;\n    min-width: 4px;\n    height: 4px;\n    border: 1px solid $submenu-bg-color;\n    border-radius: 50%;\n    margin-right: 15px;\n    position: relative;\n    box-shadow: 1px 0px 0px $sidebar-color, 0px -1px 0px $sidebar-color, 0px 1px 0px $sidebar-color,\n      -1px 0px 0px $sidebar-color;\n  }\n}\n\n%text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.pro-sidebar {\n  .pro-menu {\n    padding-top: 10px;\n    padding-bottom: 10px;\n\n    > ul {\n      > .pro-sub-menu {\n        > .pro-inner-list-item {\n          position: relative;\n          background-color: $submenu-bg-color;\n\n          > div > ul {\n            padding-top: 15px;\n            padding-bottom: 15px;\n          }\n        }\n      }\n    }\n    a {\n      text-decoration: none;\n      color: $sidebar-color;\n      &:before {\n        content: '';\n        position: absolute;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        left: 0;\n        background-color: transparent;\n      }\n      &:hover {\n        color: $highlight-color;\n      }\n    }\n    .pro-menu-item {\n      font-size: 15px;\n      &.active {\n        color: $highlight-color;\n      }\n\n      .suffix-wrapper {\n        opacity: 1;\n        transition: opacity 0.2s;\n      }\n      .prefix-wrapper {\n        display: flex;\n        margin-right: 5px;\n        opacity: 1;\n        transition: opacity 0.2s;\n      }\n\n      > .pro-inner-item {\n        position: relative;\n        display: flex;\n        align-items: center;\n        padding: 8px 35px 8px 20px;\n        cursor: pointer;\n\n        &:focus {\n          outline: none;\n          color: $highlight-color;\n        }\n        > .pro-icon-wrapper {\n          margin-right: 10px;\n          font-size: 14px;\n          width: $icon-size;\n          min-width: $icon-size;\n          height: $icon-size;\n          line-height: $icon-size;\n          text-align: center;\n          display: inline-block;\n\n          .pro-icon {\n            display: flex;\n            height: 100%;\n            align-items: center;\n            justify-content: center;\n          }\n        }\n\n        > .pro-item-content {\n          flex-grow: 1;\n          flex-shrink: 1;\n\n          @extend %text-truncate;\n        }\n\n        &:hover {\n          color: $highlight-color;\n          .pro-icon-wrapper {\n            .pro-icon {\n              animation: swing ease-in-out 0.5s 1 alternate;\n            }\n          }\n        }\n      }\n\n      &.pro-sub-menu {\n        > .pro-inner-item {\n          &:before {\n            background: $sidebar-color;\n          }\n\n          > .pro-arrow-wrapper {\n            position: absolute;\n            right: 20px;\n            top: 50%;\n            transform: translateY(-50%);\n\n            .pro-arrow {\n              display: inline-block;\n              border-style: solid;\n              border-color: $sidebar-color;\n              border-width: 0 2px 2px 0;\n              padding: 2.5px;\n              vertical-align: middle;\n              transition: transform 0.3s;\n              transform: rotate(-45deg);\n            }\n          }\n        }\n\n        &.open {\n          > .pro-inner-item {\n            &:before {\n              background: transparent !important;\n            }\n            > .pro-arrow-wrapper {\n              .pro-arrow {\n                transform: rotate(45deg);\n              }\n            }\n          }\n        }\n\n        .pro-inner-list-item {\n          padding-left: $submenu-indent;\n\n          .pro-inner-item {\n            padding: 8px 30px 8px 15px;\n\n            > .pro-icon-wrapper {\n              background: none;\n              width: auto;\n              min-width: auto;\n              height: auto;\n              line-height: auto;\n            }\n          }\n        }\n      }\n    }\n\n    &:not(.inner-submenu-arrows) {\n      .pro-inner-list-item .pro-menu-item.pro-sub-menu .pro-inner-item .pro-arrow-wrapper {\n        display: none;\n      }\n    }\n    &.submenu-bullets {\n      .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {\n        @extend %pro-item-prefix;\n      }\n    }\n\n    &.shaped {\n      .pro-menu-item {\n        > .pro-inner-item {\n          > .pro-icon-wrapper {\n            background-color: $icon-bg-color;\n          }\n        }\n      }\n    }\n\n    &.square {\n      .pro-menu-item {\n        > .pro-inner-item {\n          > .pro-icon-wrapper {\n            border-radius: 0;\n          }\n        }\n      }\n    }\n    &.round {\n      .pro-menu-item {\n        > .pro-inner-item {\n          > .pro-icon-wrapper {\n            border-radius: 4px;\n          }\n        }\n      }\n    }\n    &.circle {\n      .pro-menu-item {\n        > .pro-inner-item {\n          > .pro-icon-wrapper {\n            border-radius: 50%;\n          }\n        }\n      }\n    }\n  }\n\n  // styling when the sidebar is collapsed\n\n  &.collapsed {\n    .pro-menu {\n      > ul {\n        > .pro-menu-item {\n          > .pro-inner-item {\n            > .suffix-wrapper,\n            > .prefix-wrapper {\n              opacity: 0;\n            }\n          }\n          > .pro-inner-list-item {\n            background-color: $submenu-bg-color-collapsed;\n            z-index: 111;\n          }\n          position: relative;\n          &::before {\n            content: '';\n            display: inline-block;\n            position: absolute;\n            top: 0;\n            bottom: 0;\n            left: 0;\n            right: 0;\n            cursor: pointer;\n          }\n          &.pro-sub-menu {\n            position: relative;\n\n            > .pro-inner-item {\n              pointer-events: none;\n\n              > .pro-arrow-wrapper {\n                display: none;\n              }\n            }\n            > .pro-inner-list-item {\n              height: auto !important;\n              position: fixed;\n              visibility: hidden;\n              min-width: 220px;\n              max-width: 270px;\n              background-color: transparent;\n              max-height: 100%;\n              padding-left: 3px;\n              &.has-arrow {\n                padding-left: 10px;\n              }\n              > .popper-inner {\n                max-height: 100vh;\n                overflow-y: auto;\n                background-color: $submenu-bg-color-collapsed;\n                padding-left: 20px;\n                border-radius: 4px;\n              }\n            }\n            &:hover {\n              > .pro-inner-list-item {\n                transition: visibility, transform 0.3s;\n                visibility: visible;\n              }\n              .pro-icon-wrapper {\n                .pro-icon {\n                  animation: swing ease-in-out 0.5s 1 alternate;\n                }\n              }\n            }\n\n            .pro-inner-list-item {\n              .pro-sub-menu-item,\n              .pro-inner-item {\n                padding: 8px 30px 8px 5px;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  // styles for rtl\n  &.rtl {\n    .pro-menu {\n      .pro-menu-item {\n        .prefix-wrapper {\n          margin-right: 0;\n          margin-left: 5px;\n        }\n        > .pro-inner-item {\n          padding: 8px 20px 8px 35px;\n          > .pro-icon-wrapper {\n            margin-right: 0;\n            margin-left: 10px;\n          }\n        }\n\n        &.pro-sub-menu {\n          > .pro-inner-item {\n            > .pro-arrow-wrapper {\n              right: auto;\n              left: 20px;\n              .pro-arrow {\n                transform: rotate(135deg);\n              }\n            }\n          }\n          &.open {\n            > .pro-inner-item {\n              > .pro-arrow-wrapper {\n                .pro-arrow {\n                  transform: rotate(45deg);\n                }\n              }\n            }\n          }\n\n          .pro-inner-list-item {\n            padding-left: 0;\n            padding-right: $submenu-indent;\n\n            .pro-inner-item {\n              padding: 8px 15px 8px 30px;\n              &:before {\n                margin-right: 0;\n                margin-left: 15px;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    // styles for rtl and collapsed\n    &.collapsed {\n      .pro-menu {\n        > ul {\n          > .pro-menu-item {\n            &.pro-sub-menu {\n              > .pro-inner-list-item {\n                padding-left: 0;\n                padding-right: 3px;\n                &.has-arrow {\n                  padding-right: 10px;\n                }\n                > .popper-inner {\n                  padding-left: 0;\n                  padding-right: 20px;\n                }\n              }\n\n              .pro-inner-list-item {\n                .pro-sub-menu-item,\n                .pro-inner-item {\n                  padding: 8px 5px 8px 30px;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n",".popper-arrow {\n  position: absolute;\n  z-index: -1;\n  width: 0;\n  height: 0;\n  border-top: 7px solid transparent;\n  border-bottom: 7px solid transparent;\n}\n\n.popper-element[data-popper-placement^='left'] > .popper-arrow {\n  right: 0;\n  border-right: 7px solid $submenu-bg-color-collapsed;\n}\n\n.popper-element[data-popper-placement^='right'] > .popper-arrow {\n  left: 0;\n  border-left: 7px solid $submenu-bg-color-collapsed;\n}\n",".react-slidedown {\n  height: 0;\n  transition-property: none;\n  transition-duration: 0.2s;\n  transition-timing-function: ease-in-out;\n}\n\n.react-slidedown.transitioning {\n  overflow-y: hidden;\n}\n\n.react-slidedown.closed {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
